<script>
  import { DateTime } from "luxon";
  import Plot from "./components/Plot.svelte";

  export let data;

  function transformProject(data, project) {
    // Create the scatter trace given a project
    let filtered = data.filter((x) => x.project === project);
    let trace = {
      x: filtered.map((x) => x.submission_timestamp.substr(0, 10)),
      y: filtered.map((x) => {
        // a fractional number of the hour when the schema was deployed
        let dt = DateTime.fromISO(x.submission_timestamp, { zone: "utc" });
        return dt.hour + dt.minute / 60;
      }),
      text: filtered.map((x) => x.commit_hash),
      name: project,
      mode: "markers",
      type: "scatter",
    };
    return trace;
  }

  function transform(data) {
    return [
      transformProject(data, "moz-fx-data-shared-prod"),
      transformProject(data, "moz-fx-data-shar-nonprod-efed"),
    ];
  }

  let layout = {
    title: "Deploy time in hours since UTC midnight",
    legend: { orientation: "h" },
    yaxis: { title: { text: "hours since UTC midnight" } },
  };
</script>

<Plot {data} {transform} {layout} />
